module.exports = __webpack_public_path__ + "img/pet_avatar.7e714596.png";